<div class="my-5">
  <!--Drop Down To Select List of Countries-->
  <div class="row">
    <div class="col-md-6 mx-auto text-center">
      <h2 class="heading-black">Choose a State</h2>
      <p class="text-muted lead">For more insights</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 mx-auto text-center">
      <select class="form-control" [(ngModel)]="specificState">
        <option *ngFor="let state of states" [value]="state">{{state}}</option>
      </select><br>
      <button class="btn btn-primary" (click)="fetchSpecificData()">Get Info</button>
    </div>
  </div><br><br>
</div>
<div class="container border p-5" *ngIf="totalActiveCases!=null">
  <div class="row">
    <div class="col-sm-6">
      <div class="card shadow my-3">
        <h3 class="card-header">Active</h3>
        <div class="card-body text-info">
          <h1 class="card-title">{{totalActiveCases}}</h1>
          <h3>Total number of active cases till today</h3>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="card shadow my-3">
        <h3 class="card-header">Confirmed</h3>
        <div class="card-body text-danger">
          <h1 class="card-title">{{totalConfirmedCases}}</h1>
          <h3>Total number of confirmed cases till today</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row mt-5 bd-highlight justify-content-center">
    <div class="mx-4"><svg width="30" height="10">
        <rect width="30" height="10" style="fill:#d9534f;stroke-width:3;stroke:rgb(0,0,0)" />
        Sorry, your browser does not support inline SVG.
      </svg> &nbsp; &nbsp;
      <p>High Active Cases</p>
    </div>
    <div class="mx-4"><svg width="30" height="10">
      <rect width="30" height="10" style="fill:#f0ad4e;stroke-width:3;stroke:rgb(0,0,0)" />
      Sorry, your browser does not support inline SVG.
      </svg> &nbsp; &nbsp;
      <p>Moderate Active Cases</p>
    </div>
    <div class="mx-4"><svg width="30" height="10">
      <rect width="30" height="10" style="fill:#5cb85c;stroke-width:3;stroke:rgb(0,0,0)" />
      Sorry, your browser does not support inline SVG.
      </svg> &nbsp; &nbsp;
      <p>Low Active Cases</p>
    </div>
  </div>


  <div *ngIf="indianSpecificData!=null">
    <br><br>
    <table class="table">
      <thead>
        <tr>
          <th>District</th>
          <th>Confirmed</th>
          <th>Active</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let district of indianSpecificData.districtData | orderBy: 'active': 'reverse'"
          [ngClass]="district.active>3000 ? 'text-light bg-danger' : (district.active>1000&&district.active<3000 ? 'text-dark bg-warning' : 'text-light bg-success')">
          <td>{{ district.district}}</td>
          <td>{{ district.confirmed}}</td>
          <td>{{ district.active }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>